export const PAGE_PROPS = {
    list: [],
    totalPages: 0,
    totalRecords: 0,
};
